document.addEventListener("DOMContentLoaded", function() {
  const section = document.querySelector(".two-content-img-main-container");
  const rightContent = document.querySelector(".two-content-img-right-boxes");
  const middleImage = document.querySelector('.two-content-img-middle');
  const leftContent = document.querySelector(".two-content-img-left");

  function handleScroll() {

    const sectionRect = section.getBoundingClientRect();
    const sectionTop = sectionRect.top; 
    const sectionHeight = sectionRect.height;
    
    const scrollPosition = window.scrollY + window.innerHeight;

    if (window.innerWidth >= 990) {
       if (sectionTop < 100) {
        leftContent.classList.add("fade-out");
        rightContent.classList.add("fade-in");
      } else {
        if (sectionTop < window.innerHeight/2) {
          if (!middleImage.classList.contains("fade-in")) {
            middleImage.classList.add("fade-in");
          }
        }   
        if (sectionTop > 100) {
          leftContent.classList.remove("fade-out");
          leftContent.classList.add("fade-in");
          rightContent.classList.remove("fade-in");
        }
      }
    } else {
      if (sectionTop < window.innerHeight && sectionTop > 0 ) {
         rightContent.classList.add("fade-out");
         leftContent.classList.add("fade-in");
      } else if (-1 * sectionTop > window.innerHeight/2.5) {
        rightContent.classList.remove("fade-out");
        rightContent.classList.add("fade-in");
        leftContent.classList.remove("fade-in");
      }

      if (sectionTop < 100) {
        if (!middleImage.classList.contains("fade-in")) {
          middleImage.classList.add("fade-in");
        }
      }
    }
  }

  window.addEventListener("scroll", handleScroll);
});
